import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable,of } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { jwtDecode } from 'jwt-decode';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ApplicationService {
  private appsUrl = 'assets/applications.json';

  constructor( 
    private http: HttpClient,
    private auth: AuthService,
    private router: Router
  ) { }

  getApplications(): Observable<any> {
    return this.http.get(this.appsUrl);
  }
  checkApplicationAccess(): Observable<boolean> {
    return this.auth.getAccessTokenSilently().pipe(
      map(token => {
        if (!token) {
          console.log('No access token found');
          return false;
        }

        const decodedToken: any = jwtDecode(token);

        const scopeRoles = decodedToken.scope.split(' ').filter((scope: string) => {
          return !['openid', 'profile', 'email', 'offline_access'].includes(scope);
        });
        
        const hasAccess = scopeRoles.some((role:any) => role.includes('suphub'));

        if (!hasAccess) {
          this.router.navigate(['/unauthorized']);
        }
        return hasAccess;
      }),
      catchError(err => {
        // console.error('Error decoding token', err);
        // this.router.navigate(['/unauthorized']);
        return of(false);
      })
    );
  }
  checkIdTokenExpiration(idToken: any): void {
    if (!idToken || !idToken.exp) {
      console.warn('ID token is missing or malformed.');
      return;
    }

    const exp = idToken.exp * 1000; // Convert to milliseconds
    const now = Date.now();
    const timeUntilExpiry = exp - now;
    if (timeUntilExpiry > 0) {
      setTimeout(() => {
        console.warn('ID token expired. Logging out.');
        this.auth.logout();
      }, timeUntilExpiry);
    } else {
      console.warn('ID token already expired. Logging out immediately.');
      this.auth.logout();
    }
  }

}
